import { useNumericIdFromURL } from "./use-numeric-id-from-url";

export const useApplicationId = () => useNumericIdFromURL("applicationId");
